import styled from "styled-components";
import { ArticleDescription } from "./description";

export const ArticleDate = styled(ArticleDescription)`
  margin: 0px;
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  color: ${({ theme }) => theme.colors.grayThick};
`;
